export enum RangeType {
  SWITCHBOARD = 'SWITCHBOARD',
  TRANSFORMER = 'TRANSFORMER',
  ACCESSORIES = 'ACCESSORIES',
  FAKE = 'FAKE',
  IMPORTED = 'IMPORTED',
  BUDJETARY_QUOTE = 'BUDJETARY_QUOTE',
}
